// src/app/services/consent-text-info-rest.service.ts
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { uuid } from '../shared/utils/uuid';
import { RuntimeConfigService } from './runtime-config';

export interface ConsentTextInfo {
  getConsentByType: {
    consenttext: string;
    consenttextid: number;
    consentversion: string;
  };
}

/**
 * Fetches versioned legal consent copy by type for display in form checkboxes
 * (`GET /api/consent/type`).
 */
@Injectable({
  providedIn: 'root',
})
export class ConsentTextInfoRestService {
  constructor(
    private http: HttpClient,
    private readonly runtimeConfigService: RuntimeConfigService
  ) {}

  getConsentByType(
    consentType: string,
    correlationId: string = uuid()
  ): Observable<HttpResponse<ConsentTextInfo>> {
    const { WWW_REST_API_URI } = this.runtimeConfigService.prequalConfig;
    const headers = {
      'x-correlation-id': correlationId,
    };
    return this.http.get<ConsentTextInfo>(
      WWW_REST_API_URI + '/api/consent/type',
      { params: { consentType }, headers, observe: 'response' }
    );
  }
}
